export default {"src":"/_next/static/media/CTRA.41ff50e7.svg","height":18,"width":18};